import { render, staticRenderFns } from "./CredorStatsCount.vue?vue&type=template&id=484b91b6&"
import script from "./CredorStatsCount.vue?vue&type=script&lang=js&"
export * from "./CredorStatsCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports